// extracted by mini-css-extract-plugin
export default {"turnOffAlignment":"supplier-bid-registry-create-page_turnOffAlignment__yu388"};